export const SET_LESSONS = "SET_LESSONS";
export const SET_NET = "SET_NET";
export const SET_CORRECT_ANSWER = "SET_CORRECT_ANSWER";
export const SET_WRONG_ANSWER = "SET_WRONG_ANSWER";
export const SET_IS_DISABLED = "SET_IS_DISABLED";
export const TOGGLE_ITEM = "TOGGLE_ITEM";
export const CONTINUE_ITEM = "CONTINUE_ITEM";
export const RESET = "RESET";
